export const EmptyWrapper = (): ListWrapper<any> => {
    return {
        total: 0,
        results: []
    };
};

export interface ListWrapper<T> {
    total: number;
    results: Array<T>;
}



// WEBPACK FOOTER //
// ./src/model/ListWrapper.ts